import img_1 from '../../assets/portfolio-img/memory-game.png';
import img_2 from '../../assets/portfolio-img/my-first-10-vanila-projects.png';
import img_3 from '../../assets/portfolio-img/wordle.png';
import img_4 from '../../assets/portfolio-img/weather-mars.png';
import img_5 from '../../assets/portfolio-img/google_dino.png';
import img_6 from '../../assets/portfolio-img/sokoban_pygame.png';
import img_7 from '../../assets/portfolio-img/robo-game.png';
import img_8 from '../../assets/portfolio-img/weather-app.png';
import img_9 from '../../assets/portfolio-img/weather_2.png';
import img_10 from '../../assets/portfolio-img/eficode_library.jpg';
import img_11 from '../../assets/portfolio-img/writely.jpg';
import img_12 from '../../assets/portfolio-img/delivery-app.jpg';
import img_13 from '../../assets/portfolio-img/country-app.jpg';
import img_14 from '../../assets/portfolio-img/razoo.jpg';
import dino_pygame from '../../assets/google_dino_pygame.zip';
import sokoban_pygame from '../../assets/sokoban_pygame.zip';
import robo_game from '../../assets/robo_game.zip';
import weather_app from '../../assets/weatherapp-dmitry-sinyavskiy.zip';

export const DATA = [
  {
    id: 13,
    img: img_14,
    title: 'Razoo-Store',
    type: 'Academy project',
    description:
      'React, Typescript, Spring Boot, Java, Redux Toolkit, RTK-Query, Tailwind, AWS(S3), Docker, PostgreSQL',
    github: 'https://github.com/uch2ha/Razoo-Store',
    demo: 'https://razoo-store.netlify.app/',
    demo_name: 'Live Demo',
  },
  {
    id: 12,
    img: img_11,
    title: 'Writely-blog',
    type: 'Free-time project',
    description: 'Node, Express, React, JavaScript, Docker, PostgreSQL',
    github: 'https://github.com/Writely-blog',
    demo: 'https://writely-blog-uch2ha.netlify.app/',
    demo_name: 'Live Demo',
  },
  {
    id: 11,
    img: img_12,
    title: 'Delivery Calculator',
    type: 'Free-time project',
    description: 'React, Typescript, React-Testing-Library, Docker',
    github: 'https://github.com/uch2ha/Delivery-Calculator',
    demo: 'https://delivery-calculator-uch2ha.netlify.app/',
    demo_name: 'Live Demo',
  },
  {
    id: 10,
    img: img_13,
    title: 'Country Application',
    type: 'Free-time project',
    description: 'React, Typescript, React-Testing-Library, Materialui',
    github: 'https://github.com/uch2ha/Country-App',
    demo: 'https://country-app-uch2ha.netlify.app/',
    demo_name: 'Live Demo',
  },
  {
    id: 9,
    img: img_10,
    title: 'EfiLibrary',
    type: 'School Group Project',
    description: 'ReactTS, NodeTS, Express, Docker, MySQL, GitActions',
    github: 'https://github.com/LibraryProjectGroup',
    demo: 'https://efilibrary.netlify.app/login',
    demo_name: 'Live Demo',
  },
  {
    id: 8,
    img: img_9,
    title: 'Weather App',
    type: 'Free-time project',
    description:
      'React, JavaScript, Webpack, Koa, Docker, Mocha, React-Testing-Library',
    github: 'https://github.com/uch2ha/Weather-App',
    demo: weather_app,
    demo_name: 'Download',
  },

  {
    id: 7,
    img: img_4,
    title: 'Mars Weather',
    type: 'School Group Project',
    description: 'React, JavaScript, C#',
    github: 'https://github.com/Mars-Weather',
    demo: 'https://weather-mars.herokuapp.com/',
    demo_name: 'Live Demo',
  },
  {
    id: 6,
    img: img_8,
    title: 'Weather App',
    type: 'Free-time project',
    description: 'React, JavaScript',
    github: 'https://github.com/uch2ha/WeatherApp-React',
    demo: 'https://city-weather-uch2ha.netlify.app/',
    demo_name: 'Live Demo',
  },
  {
    id: 5,
    img: img_2,
    title: 'My First Vanila JS Projects',
    type: 'Freetime project',
    description: 'HTML, CSS, JavaScript',
    github: 'https://github.com/uch2ha/My_First_10_Vanila_JS_Projects',
    demo: 'https://my-first-10-vanila-js-projects-uch2ha.netlify.app',
    demo_name: 'Live Demo',
  },
  {
    id: 4,
    img: img_1,
    title: 'Memory Game',
    type: 'Freetime project',
    description: 'React, JavaScript',
    github: 'https://github.com/uch2ha/Memory-Game',
    demo: 'https://memory-game-react-uch2ha.netlify.app',
    demo_name: 'Live Demo',
  },
  {
    id: 3,
    img: img_3,
    title: 'Wordle',
    type: 'School Project',
    description: 'React Native',
    github: 'https://github.com/uch2ha/Wordle-Mobile',
    demo: 'https://expo.dev/@uch2ha/wordle-react-native',
    demo_name: 'Live Demo',
  },

  {
    id: 2,
    img: img_5,
    title: 'Google Dino',
    type: 'School Project',
    description: 'Python, pygame',
    github: 'https://github.com/uch2ha/google_dino_py_game',
    demo: dino_pygame,
    demo_name: 'Download',
  },
  {
    id: 1,
    img: img_6,
    title: 'Sokoban',
    type: 'School Project',
    description: 'Python, pygame',
    github: 'https://github.com/uch2ha/Sokoban_pygame',
    demo: sokoban_pygame,
    demo_name: 'Download',
  },
  {
    id: 0,
    img: img_7,
    title: 'Robo-coin',
    type: 'School Project',
    description: 'Python, pygame',
    github: 'https://github.com/uch2ha/robo_game',
    demo: robo_game,
    demo_name: 'Download',
  },
];
